import { MdSlowMotionVideo } from 'react-icons/md'

import Title from '../title/Title'
import BannerPage from '../bannerpage/BannerPage'
import Empty from '../empty/Empty'
import './video.css'
import UserAppContext from '../../hook/UserAppContext'

const Video = ({isCurrent}) => {

      if(isCurrent !== 'video') return 

      const {user, data} = UserAppContext()
      const {videos, banners} = user.user 

      if(videos.data){

            return (
                  <div className="page_content">
                        <Empty title={`Not found`} />
                  </div>
            )
      }

      const banner = banners.data ? data.banner.image : banners[0].image 
      const title = banners.data ? data.banner.title : banners[0].title 

      return (
            <div className="page_content">
                  <Title title={videos[0].title} icon={<MdSlowMotionVideo />} />
                  <div className="page_inner">
                        <BannerPage banner={banner} title={title} isCurrent={isCurrent}/>
                        <div className="pager_inner__box video">
                              <div className="wrapper_video">
                                    <div className="video_box">
                                          <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${videos[0].id_video}`} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      )
}

export default Video
